import { render } from "./CarCheckingPage.vue?vue&type=template&id=6b4113ff"
import script from "./CarCheckingPage.vue?vue&type=script&lang=js"
export * from "./CarCheckingPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__